<template>
  <div style="height: 100%;overflow-y: auto;padding:10px">
    <div class="page_header">
      <!-- tab页头 -->
      <div  style="flex:1;margin-right: 20px;">
        <el-tabs  v-model="activeTab" :key="activeTab">
          <el-tab-pane  :label="$t('maintenance.vhcRequirMaintenance')" name="vhcRequirMaintenance"></el-tab-pane>
          <el-tab-pane  :label="$t('maintenance.maintenanceHistory')" name="maintenanceHistory"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 快速链接 -->
      <div class="quickLinks">
        {{$t("maintenance.quickLinks")}}
        <span v-for="item in quickLinks" :key="item.value" :lable="item.label" :value="item.value" @click="quickLink(item.value)">{{item.lable}}</span>
        <el-button type="primary" @click="dialogClick" :size="size">{{$t("maintenance.DIYSet")}}</el-button>
      </div>
    </div>
    <el-divider></el-divider>
    <!-- 需要维保车辆 -->
    <maintananceCar v-show="activeTab == 'vhcRequirMaintenance'" :size="size"></maintananceCar>
    <!-- 维保历史记录 -->
    <maintananceRecord v-show="activeTab == 'maintenanceHistory'" :size="size"></maintananceRecord>
    <!-- 自定义提醒设置弹窗 -->
    <div>
      <el-dialog class="dialog" :title="$t('maintenance.DIYSet')" :visible.sync="dialogVisible"  width="495px" :close-on-click-modal="false">
        <!-- <kl-label title="维保提醒时间" bold :fontSize="14" style="display:flex;text-align: left;margin-bottom: 12px;"></kl-label> -->
        <div  style="text-align:left;padding-top:8px">
          <el-form :model="form"    ref="form" label-width="160px" :label-position="LanguageId == 1 ? 'right' : 'top'">
            <el-form-item :label="$t('maintenance.qualification') + '(' + $t('maintenance.day') + ')' + '：'" 
              prop="qualification"
              :rules="rulesUtils.checkNumber"
            >
              <el-input v-model.number="form.qualification" :style="{'width': LanguageId == 1 ? '280px' : ''}" :size="size"></el-input>
            </el-form-item>
            <el-form-item :label="$t('maintenance.annualInspection') + '('  + $t('maintenance.day') + ')' + '：'" 
              prop="annualInspection"
              :rules="rulesUtils.checkNumber">
              <el-input v-model.number="form.annualInspection" :style="{'width': LanguageId == 1 ? '280px' : ''}" :size="size"></el-input>
            </el-form-item>
            <el-form-item :label="$t('maintenance.insurance') + '('  + $t('maintenance.day') + ')' + '：'" 
              prop="insurance"
              :rules="rulesUtils.checkNumber">
              <el-input v-model.number="form.insurance" :style="{'width': LanguageId == 1 ? '280px' : ''}" :size="size"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$t('maintenance.operationCertificate_year') + '('  + $t('maintenance.day') + ')' + '：'" 
              prop="operationCertificate_year"
              :rules="rulesUtils.checkNumber">
              <el-input v-model.number="form.operationCertificate_year" :style="{'width': LanguageId == 1 ? '280px' : ''}" :size="size"></el-input>
            </el-form-item>
            <el-form-item :label="$t('maintenance.operationCertificate_quarter') + '('  + $t('maintenance.day') + ')' + '：'" 
              prop="operationCertificate_quarter"
              :rules="rulesUtils.checkNumber">
              <el-input v-model.number="form.operationCertificate_quarter" :style="{'width': LanguageId == 1 ? '280px' : ''}" :size="size"></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('maintenance.receiveReminders') + '：'">
              <el-radio v-model="form.radio1" label="0">{{$t("maintenance.Sms")}}</el-radio>
              <el-radio v-model="form.radio1" label="1">{{$t("maintenance.mail")}}</el-radio>
            </el-form-item>
            <el-form-item :label="phoneOraddress" prop="phone"
              :rules="form.radio2 == 1 ? form.radio1 == '0' ? rulesUtils.checkPhone : rulesUtils.checkMail : []">
              <el-input v-model="form.phone" 
                :placeholder="form.radio1 == 0 ? $t('maintenance.mulMobilePhoneAreSeparatedByAComma') : $t('maintenance.mulMailAreSeparatedByAComma')"  
                :style="{'width': LanguageId == 1 ? '280px' : ''}" 
                :size="size"></el-input>
            </el-form-item>
            <el-form-item :label="$t('maintenance.SMS_alerts')">
              <el-radio v-model="form.radio2" label="1">{{$t("maintenance.SMS_open")}}</el-radio>
              <el-radio v-model="form.radio2" label="0">{{$t("maintenance.SMS_close")}}</el-radio>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t("public.cancel")}}</el-button>
          <el-button type="primary" @click="submitSave">{{$t("public.save")}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import maintananceRecord from '@/views/maintenance/transactionReminder/maintananceRecord'
import maintananceCar from "@/views/maintenance/transactionReminder/maintananceCar.vue"
import { mapState } from "vuex";
import settings from "@/settings";
	import rules from '@/utils/rules'
import language from '@/utils/getLanguageId'
export default {
    name: "transactionReminder",
  data(){
    return{
      rulesUtils: rules,
      dialogVisible:false,
      form:{
        phone:"",
        radio1:"1",
        radio2:"1",
        qualification:0,
        operationCertificate_quarter:0,
        operationCertificate_year:0,
        insurance:0,
        annualInspection:0,
      },
      activeTab:"vhcRequirMaintenance",
      quickLinks:[
        {lable:this.$t("maintenance.NJ"),value:"NJ"},
        {lable:this.$t("maintenance.BX"),value:"BX"},
        {lable:this.$t("maintenance.BY"),value:"BY"},
      ],
      LanguageId:1,
    }
  },
  components:{maintananceCar,maintananceRecord},
  computed:{
    size() {
      return this.$store.getters.size
    },
    phoneOraddress(){
      if(this.form.radio1 == "0"){
        return this.$t("maintenance.SmsRemind");
      }else return this.$t("maintenance.mailRemid");
    },
    ...mapState({
      operator: (state) => state.user.operator,
    }),
  },
  watch:{
  },
  methods:{
    dialogClick(){
      this.dialogVisible = true;
      this.$api.queryDIYSet({
        CompanyID: this.operator.CompanyId + '',
        // CompanyID: "5657",
      })
      .then((res)=>{
        if(res.code == 200){
          this.form.qualification = res.data[0].qualification ? res.data[0].qualification : 0;
          this.form.operationCertificate_quarter = res.data[0].operationCertificate_quarter ? res.data[0].operationCertificate_quarter : 0;
          this.form.operationCertificate_year = res.data[0].operationCertificate_year ? res.data[0].operationCertificate_year : 0;
          this.form.insurance = res.data[0].insurance ? res.data[0].insurance : 0;
          this.form.annualInspection = res.data[0].annualInspection ? res.data[0].annualInspection : 0;
          this.form.radio1 = res.data[0].receive_type + '';
          this.form.radio2 = res.data[0].SMSAlerts+ '';
          this.form.phone = res.data[0].phoneOraddress;
        }
      })
    },
    quickLink(type){
      switch(type){
        case "NJ":
          this.$router.push("/maintenance/annualInspection");
          break;
        case "BX":
          this.$router.push("/maintenance/insurance");
          break;
        case "BY":
          this.$router.push("/maintenance/upkeep");
          break;
      }
    },
    submitSave(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.$api.saveDIYInfo({
              CompanyID: this.operator.CompanyId,
              // CompanyID: 5657,
              qualification: parseInt(this.form.qualification) ,
              annualInspection: parseInt(this.form.annualInspection),
              insurance: parseInt(this.form.insurance),
              // operationCertificate_year: parseInt(this.form.operationCertificate_year),
              // operationCertificate_quarter: parseInt(this.form.operationCertificate_quarter),
              receive_type: parseInt(this.form.radio1),
              SMSAlerts: parseInt(this.form.radio2),
              phoneOraddress: this.form.phone,
            })
            .then((res)=>{
              if(res && res.code == 200){
                this.$message.info(this.$t("maintenance.set_successfully"))
                this.dialogVisible = false
              }
            })
          } else {
            return ;
          }
        });
    }
  },
  mounted(){
      const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.$store.dispatch("app/closeSideBar");
    this.LanguageId = language(this.$store.getters.locale)
  },
  destroyed() {
    this.$store.dispatch("app/openSideBar");
  },
}
</script>
<style lang="scss" scoped>

.quickLinks{
  font-size:12px;
  span{
    color:#2A7AFF;
    margin-right:20px;
    cursor: pointer;
  }
}
.el-divider--horizontal{
  margin:0 0 16px 0 !important;
}
</style>